export default __webpack_public_path__ + "static/media/37.02f0a47c.png";